import React from 'react'
import { useTranslation } from 'react-i18next'
import { Box, Stack, Text, TextLink } from '@machobear/design-system'
import { useResponsiveValue } from '@machobear/design-system'
import { Userpilot } from 'userpilot'
import { colors } from '@/styles'
import EmptyImage from '../images/empty-trustscore-image'

const TrustScoreEmptyComponent = () => {
  const { t } = useTranslation()
  const isMobile = useResponsiveValue()({
    mobile: true,
    tablet: false,
    desktop: false
  })
  const getStartedLink = `/trust-score/credit-check`
  const handleLinkClick = () => {
    Userpilot.track('app_standalone_ts_getstart_anchortext')
  }
  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      flexDirection="column"
      style={{ minHeight: isMobile ? '60vh' : '40vh', backgroundColor: `${colors.white}` }}
    >
      <Box style={{ width: '350px' }} maxWidth="small" marginY="xxxlarge">
        <Stack align="center" space="large">
          <EmptyImage />
          <Stack align="center" space="medium">
            <Stack align="center" space="small">
              <Text size="medium" weight="medium">
                {t(
                  'l.standalone_trustscore.list.empty_list.no_trust_scores_found.text',
                  'No Trust Scores Found'
                )}
              </Text>
              <Text align="center">
                <TextLink href={getStartedLink} onClick={handleLinkClick}>
                  {t('l.standalone_trustscore.list.empty_list.get_started.text', 'Get started')}
                </TextLink>
              </Text>
            </Stack>
          </Stack>
        </Stack>
      </Box>
    </Box>
  )
}

export default TrustScoreEmptyComponent
